/* 🤖 this file was generated by svg-to-ts */
export const mgcIconFolderFilled: {
  name: 'folder-filled';
  data: string;
} = {
  name: 'folder-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3.58 3.046c-.736.143-1.4.822-1.537 1.571-.061.334-.061 14.432 0 14.766.141.768.806 1.433 1.574 1.574.334.061 16.432.061 16.766 0 .768-.141 1.433-.806 1.574-1.574.03-.164.043-2.077.042-6.16 0-6.515.012-6.186-.245-6.668a1.986 1.986 0 0 0-1.114-.941l-.26-.092-3.943-.001-3.942-.001-.678-.85a37.6 37.6 0 0 0-.837-1.026 2.247 2.247 0 0 0-.813-.537c-.225-.085-.256-.086-3.307-.093-1.853-.004-3.159.009-3.28.032"/></svg>`
};
